module.exports = __webpack_public_path__ + "static/media/clontarf.ac56cffb.png";